// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nzk9","option":"styles_option__2n2_c","selected":"styles_selected__LrvK3"};